<template>
    <div class="j-page-layout">
        <div class="j-page-layout-left-side_wrap">
            <slot name="left-side"></slot>
        </div>
        <div class="j-page-layout_wrap">
            <slot></slot>
            <div class="j-page-layout_wrap__header">
                <slot name="header"></slot>
            </div>
            <div class="j-page-layout_wrap__search">
              <slot name="search" />
              <slot name="btn" />
            </div>
            <div class="j-page-layout_wrap__table">
                <slot name="table"></slot>
            </div>
            <div class="j-page-layout_wrap__pagination">
                <slot name="pagination"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'JPage'
}
</script>

<style scoped lang="scss">
    .j-page-layout {
        display: flex;
        position: relative;
        height: 100%;
        width: 100%;
        background: #fff;
        padding: 15px;
        box-sizing: border-box;

        .j-page-layout-left-side_wrap {
            height: 100%;
            > * {
                margin-right: 10px;
            }
        }

        .j-page-layout_wrap {
            flex: 1;
            display: flex;
            flex-direction: column;
            height: 100%;
            min-width: 100px;
            box-sizing: border-box;
        }
        .j-page-layout_wrap__header {
            > * {
                margin-bottom: 10px;
            }
        }
        .j-page-layout_wrap__search {
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            .search-button-left { flex: 1; min-width: 140px; }
            .search-button-right {}
            > * {
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                margin-bottom: 10px;
                width: 100%;
            }
            .el-button, .el-dropdown, .j-page-search-wrap {
                margin: 0 10px 10px 0;
            }
        }

        .j-page-layout_wrap__table {
            min-height: 100px;
            flex: 1;
            overflow-x: hidden;
            overflow-y: auto;
            box-sizing: border-box;
            padding-bottom: 10px;
            > * {
                height: 100%;
            }
        }

        .j-page-layout_wrap__pagination {
            > * {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                padding-bottom: 10px;
            }
        }
    }
</style>
